'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = exports.easing = undefined;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-param-reassign */

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easingInternal = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0.0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
  // For snackbar and associated fab transforms.
  snackbar: 'ease-out'
};

// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
var durationInternal = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // Most basic recommended timing.
  standard: 300,
  // This is to be used in complex animations.
  complex: 375,
  // Recommended when something is entering screen.
  enteringScreen: 225,
  // Recommended when something is leaving screen.
  leavingScreen: 195,
  // For snackbar and associated fab transforms.
  snackbar: 400
};

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};

/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */
exports['default'] = {
  easing: easingInternal,

  duration: durationInternal,

  create: function () {
    function create() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _ref$duration = _ref.duration,
          duration = _ref$duration === undefined ? durationInternal.short : _ref$duration,
          _ref$easing = _ref.easing,
          easing = _ref$easing === undefined ? easingInternal.easeInOut : _ref$easing,
          _ref$delay = _ref.delay,
          delay = _ref$delay === undefined ? 0 : _ref$delay,
          other = _objectWithoutProperties(_ref, ['duration', 'easing', 'delay']);

      (0, _warning2['default'])(typeof props === 'string' || Array.isArray(props), 'argument "props" must be a string or Array');
      (0, _warning2['default'])(isNumber(duration), 'argument "duration" must be a number');
      (0, _warning2['default'])(typeof easing === 'string', 'argument "easing" must be a string');
      (0, _warning2['default'])(isNumber(delay), 'argument "delay" must be a string');
      (0, _warning2['default'])(Object.keys(other).length === 0, 'unrecognized argument(s) [' + Object.keys(other).join(',') + ']');

      return (Array.isArray(props) ? props : [props]).map(function (value) {
        return value + ' ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
      }).join(',');
    }

    return create;
  }(),
  getAutoHeightDuration: function () {
    function getAutoHeightDuration(height) {
      if (!height) {
        return 0;
      }

      var constant = height / 36;
      var duration = (4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10;

      return Math.round(duration);
    }

    return getAutoHeightDuration;
  }()
};

/**
 * @deprecated Will be removed, please access via theme.transitions.easing
 */

var easing = exports.easing = easingInternal;
/**
 * @deprecated Will be removed, please access via theme.transitions.duration
 */
var duration = exports.duration = durationInternal;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/transitions.js
// module id = 120
// module chunks = 32